/* Dom Atts */
export enum ModalPosition {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum Layout {
  Mobile = 'mobile',
  Responsive = 'responsive',
}

export enum Country {
  US = 'UNITED_STATES',
  CA = 'CANADA',
}
